import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-435d27a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "tab" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { class: "tab-pane" }
const _hoisted_8 = { class: "tab-pane-body" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "tab-pane" }
const _hoisted_11 = { class: "tab-pane-body" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rule-root", { 'is-not-ipad': !_ctx.isIpadProDevice }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('menu.gamerules')), 1),
        _createVNode(_component_icon_x, {
          class: "close",
          onClickPassive: _ctx.close
        }, null, 8, ["onClickPassive"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", { active: _ctx.tabIndex === 0 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tabIndex = 0))
          }, _toDisplayString(_ctx.t('baccarat.name')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", { active: _ctx.tabIndex === 1 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tabIndex = 1))
          }, _toDisplayString(_ctx.t('dragontiger.name')), 3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "rules",
                innerHTML: _ctx.t('rules.baccarat')
              }, null, 8, _hoisted_9)
            ])
          ], 512), [
            [_vShow, _ctx.tabIndex === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "rules",
                innerHTML: _ctx.t('rules.dragontiger')
              }, null, 8, _hoisted_12)
            ])
          ], 512), [
            [_vShow, _ctx.tabIndex === 1]
          ])
        ])
      ])
    ])
  ], 2))
}